var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ccl-wrap" },
    [
      _c(
        "div",
        { staticClass: "ccl-header" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
              on: { click: _vm.openCreate }
            },
            [_vm._v("\n      New Coupon\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "ccl-stats" }, [
        _c("div", { staticClass: "ccl-stat" }, [
          _c("span", { staticClass: "ccl-stat__val" }, [
            _vm._v(_vm._s(_vm.coupons.length))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ccl-stat__key" }, [_vm._v("Total")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ccl-stat ccl-stat--green" }, [
          _c("span", { staticClass: "ccl-stat__val" }, [
            _vm._v(_vm._s(_vm.activeCoupons))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ccl-stat__key" }, [_vm._v("Active")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ccl-stat ccl-stat--gray" }, [
          _c("span", { staticClass: "ccl-stat__val" }, [
            _vm._v(_vm._s(_vm.inactiveCoupons))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ccl-stat__key" }, [_vm._v("Inactive")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ccl-stat ccl-stat--blue" }, [
          _c("span", { staticClass: "ccl-stat__val" }, [
            _vm._v(_vm._s(_vm.totalUses))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ccl-stat__key" }, [_vm._v("Total Uses")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ccl-toolbar" },
        [
          _c("el-input", {
            staticClass: "ccl-search",
            attrs: {
              placeholder: "Search by title or code…",
              size: "small",
              "prefix-icon": "el-icon-search",
              clearable: ""
            },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "ccl-filter",
              attrs: { size: "small", placeholder: "All Status" },
              model: {
                value: _vm.filterStatus,
                callback: function($$v) {
                  _vm.filterStatus = $$v
                },
                expression: "filterStatus"
              }
            },
            [
              _c("el-option", { attrs: { label: "All Status", value: "" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "Active", value: "active" } }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "Inactive", value: "inactive" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "ccl-table-wrap"
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.pagedCoupons,
                "show-header": _vm.filteredCoupons.length > 0
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "Coupon", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "ccl-coupon-cell" }, [
                          _c(
                            "span",
                            {
                              staticClass: "ccl-code",
                              class:
                                row.coupon_type === "percent"
                                  ? "ccl-code--purple"
                                  : "ccl-code--teal"
                            },
                            [_vm._v(_vm._s(row.code))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "ccl-coupon-title" }, [
                            _vm._v(_vm._s(row.title))
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Discount", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "ccl-discount",
                            class:
                              row.coupon_type === "percent"
                                ? "ccl-discount--purple"
                                : "ccl-discount--teal"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.coupon_type === "percent"
                                    ? row.amount + "% OFF"
                                    : "$" +
                                        parseFloat(row.amount).toFixed(2) +
                                        " OFF"
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Usage", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "ccl-usage" },
                          [
                            _c("div", { staticClass: "ccl-usage__label" }, [
                              _c("span", { staticClass: "ccl-usage__used" }, [
                                _vm._v(_vm._s(row.used_count))
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "ccl-usage__sep" }, [
                                _vm._v(" / ")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "ccl-usage__max" }, [
                                _vm._v(
                                  _vm._s(row.max_use > 0 ? row.max_use : "∞")
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            row.max_use > 0
                              ? _c("el-progress", {
                                  staticStyle: { "margin-top": "4px" },
                                  attrs: {
                                    percentage: Math.min(
                                      100,
                                      Math.round(
                                        (row.used_count / row.max_use) * 100
                                      )
                                    ),
                                    "show-text": false,
                                    "stroke-width": 3,
                                    color:
                                      row.used_count >= row.max_use
                                        ? "#f56c6c"
                                        : "#409eff"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Expiry", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.expire_date
                          ? _c(
                              "span",
                              {
                                staticClass: "ccl-expiry",
                                class: {
                                  "ccl-expiry--expired": _vm.isExpired(row)
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(row.expire_date.substring(0, 10)) +
                                    "\n          "
                                )
                              ]
                            )
                          : _c("span", { staticClass: "ccl-muted" }, [
                              _vm._v("No expiry")
                            ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Status", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "ccl-status",
                            class:
                              row.status === "active"
                                ? "ccl-status--on"
                                : "ccl-status--off"
                          },
                          [
                            _c("span", { staticClass: "ccl-dot" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.status === "active"
                                    ? "Active"
                                    : "Inactive"
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { width: "80", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "ccl-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "ccl-btn ccl-btn--edit",
                              attrs: { title: "Edit" },
                              on: {
                                click: function($event) {
                                  return _vm.openEdit(row)
                                }
                              }
                            },
                            [_c("i", { staticClass: "el-icon-edit" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "ccl-btn ccl-btn--del",
                              attrs: { title: "Delete" },
                              on: {
                                click: function($event) {
                                  return _vm.confirmDelete(row)
                                }
                              }
                            },
                            [_c("i", { staticClass: "el-icon-delete" })]
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading && _vm.filteredCoupons.length === 0
            ? _c(
                "div",
                { staticClass: "ccl-empty" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "ccl-empty__title" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.search || _vm.filterStatus
                            ? "No coupons match your filters"
                            : "No coupons yet"
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.search && !_vm.filterStatus
                    ? _c("p", { staticClass: "ccl-empty__sub" }, [
                        _vm._v(
                          "\n        Create your first discount code to start offering savings\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.search && !_vm.filterStatus
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-top": "12px" },
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-plus"
                          },
                          on: { click: _vm.openCreate }
                        },
                        [_vm._v("\n        Create First Coupon\n      ")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.filteredCoupons.length > _vm.pageSize
        ? _c(
            "div",
            { staticClass: "ccl-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, prev, pager, next",
                  total: _vm.filteredCoupons.length,
                  "page-size": _vm.pageSize,
                  "current-page": _vm.currentPage
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function($event) {
                    _vm.currentPage = $event
                  },
                  "current-change": function($event) {
                    _vm.currentPage = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CreateCoupon", {
        attrs: { visible: _vm.dialogVisible, "coupon-data": _vm.currentCoupon },
        on: {
          close: function($event) {
            _vm.dialogVisible = false
          },
          saved: _vm.fetchCoupons
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ccl-header__left" }, [
      _c("div", { staticClass: "ccl-header__icon" }, [
        _c("i", { staticClass: "el-icon-s-ticket" })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h2", { staticClass: "ccl-header__title" }, [
          _vm._v("Discount Coupons")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "ccl-header__sub" }, [
          _vm._v("Manage discount codes for your payment forms")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ccl-empty__icon-wrap" }, [
      _c("i", { staticClass: "el-icon-s-ticket" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }